<template>
    <div class="transfer">
        <Header ref="header" :title="title" :titleRight="titleRight" @backPage="onBack" @submit="onDone"></Header>
        <div>
            <div class="h3">请汇款至以下账户：</div>
            <div class="bank">
                <div class="bankS">
                    <div class="p">
                        <div class="p-left">开户名</div>
                        <div class="p-right">{{ details.accountName }}</div>
                    </div>
                    <div class="p">
                        <div class="p-left">开户行</div>
                        <div class="p-right">{{details.city}}{{details.bank}}{{details.subbranchAddress}}</div>
                    </div>
                    <div class="p">
                        <div class="p-left zh">账号</div>
                        <div class="p-right bk">{{details.bankNo}}</div>
                    </div>
                </div>
            </div>
            <div class="msg">转账后请联系平台公司，确认转账结果</div>
            <div class="myfw" v-if="exclusiveService.name">
                <h3>我的专属服务</h3>
                <div class="main">
                    <div class="m-left">
                        <p>姓名：{{exclusiveService.name}}</p>
                        <p>电话：{{exclusiveService.mobile}}</p>
                    </div>
                    <div class="m-right" @click="onPhone(exclusiveService.mobile)">
                        <img src="../../../assets/img/b2b/phone.jpg" alt="">
                    </div>
                </div>
            </div>
            <div class="btn f32" :class="{'btnCopy': active}" @click="onPayment">我已支付</div>
        </div>
    </div>
</template>
<script>
import Header from '../../common/header'
import { versions } from '../../common/version'
import { mapState, mapActions } from 'vuex'
import { Toast } from 'vant'
export default {
    name: 'transfer',
    components: {
        Header
    },
    data () {
        return {
            title: '公司转账',
            titleRight: '完成',
            active: false,
            price: 0,
            memberCode: '',
            merchantCode: '',
            exclusiveService: {},
            details: {}
        }
    },
    computed: {
        ...mapState({
            paymentAmount: state => state.b2b.money
        })
    },
    methods: {
        ...mapActions(['getMyServerData', 'findAcconutDetailsData', 'getPaymentInformData']),
        onBack () {
            this.$router.push({ path: '/b2b/order/orderList' })
        },
        onPhone (phone) {
            if (!phone) {
                return false
            }
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'callPhone',
                    'phoneNum': phone
                })
            } else {
                window.kfxt.callPhone(phone)
            }
        },
        onDone () {
            this.$router.push({
                path: '/b2b/order/index',
                query: {
                    num: ''
                }
            })
        },
        async onPayment () {
            if (this.active) {
                return false
            }
            await this.getPaymentInformData({
                memberCode: this.memberCode,
                merchantCode: this.merchantCode,
                payAmount: this.price
            }).then((data) => {
                this.active = true
                Toast('本次支付需平台公司确认，请耐心等待！')
            })
        },
        async findAcconutDetails () {
            await this.findAcconutDetailsData({
                merchantCode: this.merchantCode
            }).then((data) => {
                this.details = { ...data }
            })
        },
        async findExclusiveService () {
            await this.getMyServerData({ memberCode: this.memberCode }).then((data) => {
                this.exclusiveService = { ...data }
            })
        }
    },
    mounted () {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.price = localStorage.getItem('transferPrice')
        this.memberCode = userInfo.companyCode
        this.merchantCode = userInfo.belongMerchantCode
        this.findExclusiveService()
        this.findAcconutDetails()
    }
}
</script>
<style lang="scss" scoped>
    .transfer{
        font-size: 28px;
        padding: 0 24px;
        background: #f5f5f5;
        .h3{
            font-size: 30px;
            padding: 40px 0 10px;
        }
        .bank{
            background: -webkit-linear-gradient(left, #FF9B65 , #FF7A45); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(right, #FF9B65, #FF7A45); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(right, #FF9B65, #FF7A45); /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, #FF9B65 , #FF7A45); /* 标准的语法 */
            box-shadow:0px 1px 5px 1px rgba(0,0,0,0.06);
            border-radius:6px;
            .bankS{
                background: url('../../../assets/img/b2b/image_bank@2x.png') no-repeat;
                background-size: 420px 130px;
                background-position: bottom right;
                padding: 26px 40px 58px;
                .p{
                    display: flex;
                    justify-content: flex-start;
                    color: #ffffff;
                    margin-top: 40px;
                    .p-left{
                        flex: 0 0 90px;
                        text-align: right;
                        &.zh{
                            line-height:60px;
                        }
                    }
                    .p-right{
                        margin-left: 40px;
                        &.bk{
                            font-size: 44px;
                        }
                    }
                }
            }
        }
        .msg{
            font-size: 26px;
            color: #8E8E93;
            margin: 10px 0 30px;
        }
        .btn{
            height: 96px;
            border-radius: 96px;
            background: #FF7A45;
            text-align: center;
            line-height: 96px;
            color: #ffffff;
            margin-top: 80px;
            &.btnCopy{
                background: #eaeaea;
                color: #c7c7c7;
            }
        }
        .myfw{
            background: #ffffff;
            box-shadow: 0px 2px 10px 2px rgba(0,0,0,0.06);
            border-radius: 12px;
            h3{
                height: 88px;
                text-align: center;
                line-height: 88px;
                font-size: 32px;
                color: #ffffff;
                background: -webkit-linear-gradient(left, #FFB27B , #FF7A45, #FE6EB2); /* Safari 5.1 - 6.0 */
                background: -o-linear-gradient(right, #FFB27B , #FF7A45, #FE6EB2); /* Opera 11.1 - 12.0 */
                background: -moz-linear-gradient(right, #FFB27B , #FF7A45, #FE6EB2); /* Firefox 3.6 - 15 */
                background: linear-gradient(to right, #FFB27B , #FF7A45, #FE6EB2); /* 标准的语法（必须放在最后） */
                border-top-left-radius: 12px;
                border-top-right-radius: 12px;
            }
            .main{
                padding: 40px 40px 16px;
                display: flex;
                justify-content: space-between;
                .m-left{
                    p{
                        margin-bottom: 20px;
                    }
                }
                .m-right{
                    width: 60px;
                    height: 60px;
                }
            }
        }
    }
</style>